import { Box, Typography } from '@mui/material';
import { hotelViewStyles } from './styles';

interface HotelImage {
  url: string;
}

interface HotelImageGalleryProps {
  images: HotelImage[];
  onImageClick: (index: number) => void;
}

export const HotelImageGallery = ({ images, onImageClick }: HotelImageGalleryProps) => {
  if (!images.length) return null;

  const remainingImages = images.length - 4;

  return (
    <Box sx={hotelViewStyles.imageGallery}>
      <Box sx={hotelViewStyles.mainImage}>
        <Box
          component="img"
          src={images[0]?.url}
          alt="Hotel main view"
          sx={hotelViewStyles.imageBox}
          onClick={() => onImageClick(0)}
        />
      </Box>

      {images[1] && (
        <Box sx={hotelViewStyles.sideImagesContainer}>
          <Box sx={hotelViewStyles.sideImageBox}>
            <Box
              component="img"
              src={images[1]?.url}
              alt="Hotel view 2"
              sx={hotelViewStyles.imageBox}
              onClick={() => onImageClick(1)}
            />
          </Box>

          {images[2] && (
            <Box sx={hotelViewStyles.sideImageBox}>
              <Box
                component="img"
                src={images[2]?.url}
                alt="Hotel view 3"
                sx={hotelViewStyles.imageBox}
                onClick={() => onImageClick(2)}
              />
            </Box>
          )}

          {images[3] && (
            <Box sx={hotelViewStyles.sideImageBox}>
              <Box
                component="img"
                src={images[3]?.url}
                alt="More hotel images"
                sx={hotelViewStyles.imageBox}
                onClick={() => onImageClick(3)}
              />
              {remainingImages > 0 && (
                <Box
                  sx={hotelViewStyles.imageOverlay}
                  onClick={() => onImageClick(3)}
                >
                  <Typography color="white" fontWeight="bold">
                    +{remainingImages} más
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
